<template>
  <div v-if="productsInCart" class="badge e2e-cart-badge">
    {{ productsInCart }}
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";

export default {
  name: "Badge",
  computed: {
    ...mapGetters("cart", {
      quantity: "quantity",
    }),
    ...mapState({
      productsInCart: (state) => state.cart.products?.length,
    }),
  },
};
</script>

<style scoped>
.badge {
  position: absolute;
  top: -5px;
  right: -5px;
  background: #41b029;
  border-radius: 50%;
  color: #ffffff;
  font-size: 11px;
  min-width: 1.5em;
  padding: 0.05em;
  text-align: center;
  z-index: 2;
}
@media (min-width: 668px) {
  .badge {
    font-size: 15px;
    min-width: 1.7em;
    padding: 0.1em;
    top: 10px;
    right: 20px;
  }
}
</style>
